// NPM
import React, { useEffect, useState } from 'react'
import OrderDetails from 'Components/order/order-details'
import { useRecoilState } from "recoil";
import { useTranslation } from 'react-i18next';
import { isNil } from "lodash";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// ATOM
import { orderAtom } from "Recoil/order.atom";
import { CartAtom } from 'Recoil/order.atom';

// SERVICE
import { fetchProductData } from "Services/inventory.services";
import { fetchOrderById, downloadReceipt, fetchDispatchDetails } from 'Services/order.services';

// HELPERS
import { decode } from 'Helpers/enc';
import { toaster, encode } from 'Helpers/index';

// ANT COMPONENT
import { Badge } from 'antd';

// HOOKS
import useSession from 'Hooks/session.hook';

interface OrderDetailsPageDetailsPageProps {

}

const OrderDetailsPage: React.FC<OrderDetailsPageDetailsPageProps> = () => {
    const { id } = useParams<{ id: string }>();
    const orderId = decode(id);
    const { t } = useTranslation();

    const { profile } = useSession()
    const [orderState, setOrderState] = useRecoilState<any>(orderAtom);
    const [orderList, setOrderList] = useState<any>([])

    useEffect(() => {
        fetchOrders()
    }, [orderId])

    const [dispatchesList, setDispatchList] = useState([]);

    const [dispatchedData, setDispatchedData] = useState({});

    const fetchOrders = async () => {

        let filters = {
            "_id": orderId
        }
        const responseData = await fetchOrderById(filters);

        if (!isNil(responseData)) {
            let orderArray: any = [];
            if (!isNil(responseData.dispatches) && responseData.dispatches[0]?.trackingNumber) {
                const dispatchesList = await fetchDispatchDetails(responseData.dispatches[0].trackingNumber)
                responseData.deliveryUpdates = dispatchesList;
                setDispatchedData(responseData.dispatches[0]);
            }
            orderArray.push(responseData)
            setOrderList(orderArray);

            //setDispatchList(dispatchesList)
        }
    }

    const handleReceipt = async (obj) => {

        setOrderState({ ...orderState, status: { ...orderState.status, receipt: 'loading' } });

        const responseData = await downloadReceipt(obj);

        if (!isNil(responseData) && !isNil(responseData.receipt)) {
            setOrderState({
                ...orderState,
                status: { ...orderState.status, receipt: 'success', data: responseData.receipt },

            });
        }
        else {
            setOrderState({
                ...orderState,
                status: { ...orderState.status, receipt: 'failed' }
            });
            toaster('error', t("toaster.failedToGetReceipt"));
        }

    }

    return (
        <React.Fragment>

            <Helmet>
                <title>{t('pageTitle.orderDetails')}</title>
            </Helmet>

            <div className="page--container">
                {/*<div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                    <h4 className="title" style={{ color: '#85c442', fontSize: '24px' }}>{t('title.orderDetails')}</h4>
                </div>*/}
                <OrderDetails
                    status={orderState.status}
                    getReceipt={handleReceipt}
                    orderList={orderList}
                    dispatchedData={dispatchedData}
                //dispatchesList={dispatchesList}
                />
            </div>
        </React.Fragment >
    )
}

export default OrderDetailsPage;
